export default {
  create_title: 'Neues Partner-API-Konto',
  edit_title: 'Konto bearbeiten',
  form: {
    name: 'Kontoname',
    name_placeholder: 'z. B. Acme-Kassensystem',
    contact_email: 'Kontakt-E-Mail',
    scope: 'Restaurant-Zugriff',
    companies: 'Restaurants',
    scope_selected: 'Ausgewählte Restaurants',
    scope_all: 'Alle Restaurants',
    scope_all_help: 'Schlüssel dieses Kontos erreichen alle Restaurants Ihrer Organisation, auch später registrierte.',
    companies_placeholder: 'Restaurants auswählen',
    companies_help: 'Schlüssel dieses Kontos können ausschließlich diese Restaurants lesen und schreiben.',
    is_active: 'Aktiv',
    is_active_help: 'Inaktive Konten werden bei der Authentifizierung abgelehnt.',
  },
  buttons: {
    cancel: 'Abbrechen',
    save: 'Speichern',
    create: 'Erstellen',
  },
  toasts: {
    created: 'Partner-API-Konto erstellt.',
    updated: 'Konto aktualisiert.',
    error: 'Das Konto konnte nicht gespeichert werden.',
  },
};
